module.exports = __webpack_public_path__ + "static/media/matilde-sad.ce3cbbf4.png";